import { useState } from 'react'
import { Typography, Button, Divider } from '@mui/material'
import { useTranslation } from 'react-i18next'
import InCardStack, { ColStack } from 'components/atoms/container/InCardStack'
import RowStack from 'components/atoms/container/RowStack'
import colors from 'styles/colors'
import { formatDate } from 'utils/formatDateTime'
import BoxWithBackground from 'components/atoms/container/BoxWithBackground'
import NoOpenAssessmentDialog from 'components/molecules/notificationOverlay/NoOpenAssessmentDialog'
import AddMoreRatersPopup from 'components/molecules/assessments/AddMoreRatersPopup'

const AssessmentInfo = ({ goalData, timelineData }) => {
  const { t, i18n } = useTranslation()
  const [openNoOpenAssessmentNote, setOpenNoOpenAssessmentNote] =
    useState(false)
  const [addRaterOpen, setAddRaterOpen] = useState(false)

  const ScoreText = ({ label, score, color = 'primary' }) => {
    return (
      <InCardStack spacing={0}>
        <Typography variant='body1KindaSmall' color='primary'>
          {label}
        </Typography>
        <Typography
          variant='h1'
          fontSize={48}
          lineHeight={'110%'}
          color={color}>
          {score}
        </Typography>
      </InCardStack>
    )
  }
  const ScoreBox = () => {
    return (
      <BoxWithBackground
        backgroundColor={colors.White}
        padding={8}
        borderRadius={3}
        showBoxShadow={true}>
        <RowStack spacing={12} justifyContent={'center'}>
          <ScoreText
            label={t('goalsArea.self')}
            score={timelineData?.selfAllBehaviourAvg?.toFixed(1)}
            color={colors.Teal400}
          />
          <Divider
            orientation='vertical'
            sx={{
              height: 38,
              borderColor: colors.Grey200
            }}
          />
          <ScoreText
            label={t('goalsArea.others')}
            score={
              timelineData?.othersAllBehaviourAvg > 0
                ? timelineData?.othersAllBehaviourAvg?.toFixed(2)
                : '-'
            }
          />
        </RowStack>
      </BoxWithBackground>
    )
  }

  const handleAddRatersClick = () => {
    if (!timelineData?.isOpen) {
      setOpenNoOpenAssessmentNote(true)
    } else {
      setAddRaterOpen(true)
    }
  }

  const handleNoOpenAssesmentNoteClose = () => {
    setOpenNoOpenAssessmentNote(false)
  }

  return (
    <>
      <ColStack spacing={8} width={260}>
        <ColStack spacing={4}>
          <Typography variant='h2'>
            {t('assessmentTimeline.latest360')}
          </Typography>
          <Typography variant='h3' color='textSecondary'>
            {formatDate(timelineData?.ratingTimeStamp, i18n.resolvedLanguage)}
          </Typography>
        </ColStack>

        <ScoreBox />

        <Typography color='textSecondary'>
          {t('assessmentTimeline.compareScoresOthers')}
        </Typography>

        {goalData.enableOthersAssessment && (
          <Button onClick={() => handleAddRatersClick()} size='small'>
            {t('assessmentTimeline.inviteOthersAssess')}
          </Button>
        )}

        <Typography variant='body1Small' color={'error'}>
          {timelineData.isOpen
            ? t('assessmentTimeline.closing')
            : t('assessmentTimeline._360Closed')}
          {` ${formatDate(timelineData.closingTimeStamp, i18n.resolvedLanguage)}`}
        </Typography>
      </ColStack>

      <NoOpenAssessmentDialog
        open={openNoOpenAssessmentNote}
        handleDialogClose={handleNoOpenAssesmentNoteClose}
        goalId={goalData.id}
        goalName={goalData.name}
        existingRaterCount={timelineData[0]?.raters.length}
      />
      <AddMoreRatersPopup
        open={addRaterOpen}
        setOpen={setAddRaterOpen}
        goalId={goalData.id}
        assessmentData={timelineData[0]}
      />
    </>
  )
}
export default AssessmentInfo
